import { writable } from 'svelte/store';


export let lang = writable('En');

